import { createContext, type ReactNode, useContext } from "react";

import type { ConnectedProjectDto } from "@/api/types";
import type { PortfolioProjectFilterValues } from "@/components/ProjectFilter/PortfolioProjectFilterFields";

type ProjectAnalyticsScope = {
  type: "project";
};

export type PortfolioAnalyticsScope = {
  type: "portfolio";
  projectIds: string[];
  isLoading: boolean;
  filterAction: ReactNode;
  projectFilter: {
    projects: ConnectedProjectDto[];
    value: PortfolioProjectFilterValues;
    activeCount: number;
    onChange: (value: PortfolioProjectFilterValues) => void;
  };
};

export type AnalyticsScope = ProjectAnalyticsScope | PortfolioAnalyticsScope;

const AnalyticsScopeContext = createContext<AnalyticsScope>({ type: "project" });

export function AnalyticsScopeProvider({
  value,
  children,
}: {
  value: AnalyticsScope;
  children: ReactNode;
}): React.ReactNode {
  return <AnalyticsScopeContext.Provider value={value}>{children}</AnalyticsScopeContext.Provider>;
}

export function useAnalyticsScope(): AnalyticsScope {
  return useContext(AnalyticsScopeContext);
}
